An opaque cursor to the earlier bounding page.

Resulting position profiles will _succeed_ this cursor.
